/* global axios */
// Google Ads ekranlarinin ortak yardimcilari.
//
// Chatwoot kimlik basliklarini AYRI bir axios ornegine koyuyor ve onu
// window.axios olarak yayinliyor. "import axios from 'axios'" ham
// kutuphaneyi getirir, basliklar gitmez ve istek 401 doner.

export const taban = accountId => `/api/v1/accounts/${accountId}/google-ads`;

// Secili tarih araligi butun ekranlarda ortak; kullanici bir ekranda 7 gun
// secip digerine gectiginde secimin kaybolmasi rahatsiz ediciydi.
const ARALIK_ANAHTARI = 'omnup_google_ads_aralik';

export const aralikOku = () => {
  try {
    return window.localStorage.getItem(ARALIK_ANAHTARI) || '30';
  } catch {
    return '30';
  }
};

export const aralikYaz = deger => {
  try {
    window.localStorage.setItem(ARALIK_ANAHTARI, deger);
  } catch {
    // Gizli sekmede localStorage yazilamiyor; secim o oturumda kaybolur,
    // ekran yine calisir.
  }
};

export const ARALIKLAR = [
  { deger: 'bugun', anahtar: 'GOOGLE_ADS.ARALIK.BUGUN' },
  { deger: 'dun', anahtar: 'GOOGLE_ADS.ARALIK.DUN' },
  { deger: '7', anahtar: 'GOOGLE_ADS.ARALIK.YEDI' },
  { deger: '14', anahtar: 'GOOGLE_ADS.ARALIK.ONDORT' },
  { deger: '30', anahtar: 'GOOGLE_ADS.ARALIK.OTUZ' },
  { deger: 'bu_ay', anahtar: 'GOOGLE_ADS.ARALIK.BU_AY' },
  { deger: 'gecen_ay', anahtar: 'GOOGLE_ADS.ARALIK.GECEN_AY' },
];

// Tek giris noktasi: her ekran ayni hata bicimini aliyor.
export const getir = async (accountId, yol, parametreler = {}) => {
  const { data } = await axios.get(`${taban(accountId)}/${yol}`, {
    params: parametreler,
  });
  return data;
};

export const gonder = async (accountId, yol, govde = {}) => {
  const { data } = await axios.post(`${taban(accountId)}/${yol}`, govde);
  return data;
};

export const hataMetni = (e, varsayilan) =>
  e?.response?.data?.error || e?.message || varsayilan;

// --- Bicimleme -------------------------------------------------------------

export const sayi = deger =>
  typeof deger === 'number'
    ? new Intl.NumberFormat('tr-TR').format(deger)
    : '—';

export const para = (deger, birim) => {
  if (typeof deger !== 'number') return '—';
  try {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: birim || 'TRY',
      maximumFractionDigits: 2,
    }).format(deger);
  } catch {
    // Google bilinmeyen bir para birimi kodu dondurebilir; sayiyi
    // gostermek hic gostermemekten iyi.
    return `${deger} ${birim || ''}`.trim();
  }
};

export const yuzde = deger =>
  typeof deger === 'number' ? `%${deger.toFixed(2)}` : '—';

// Google sabitleri BUYUK_HARF geliyor; okunur hale getiriyoruz.
export const etiket = deger =>
  String(deger || '')
    .replaceAll('_', ' ')
    .toLowerCase()
    .replace(/(^|\s)\S/g, s => s.toUpperCase()) || '—';

// Durum rozetinin rengi. ENABLED yesil, PAUSED sari, kalanlar notr.
export const durumRengi = durum => {
  switch (String(durum || '').toUpperCase()) {
    case 'ENABLED':
    case 'OPEN':
      return 'text-n-teal-11 bg-n-alpha-1';
    case 'PAUSED':
      return 'text-n-amber-11 bg-n-alpha-1';
    case 'REMOVED':
    case 'CLOSED':
      return 'text-n-ruby-11 bg-n-alpha-1';
    default:
      return 'text-n-slate-11 bg-n-alpha-1';
  }
};
